export const LOCATION_SCHOOL_FETCH_ALL = 'LOCATION_SCHOOL_FETCH_ALL';
export const LOCATION_SCHOOL_FETCH_ALL_INIT = 'LOCATION_SCHOOL_FETCH_ALL_INIT';
export const LOCATION_SCHOOL_FETCH_ALL_DONE = 'LOCATION_SCHOOL_FETCH_ALL_DONE';

export const LOCATION_SCHOOL_CLEAR = 'LOCATION_SCHOOL_CLEAR';
